import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../util/theme';

const FooterSocial = styled.div`
  display: flex;
  justify-content: space-evenly;

  img {
    border: 2px solid transparent;
    border-radius: 50%;

    height: 40px;
    width: 40px;

    margin: 0 10px;

    &:hover {
      border: 2px solid ${getColor('accentGreen')};
    }
  }
`;

export default FooterSocial;
